/* Trendymark · movimiento (tm-*) — revelado, contadores, parallax, botón fijo. Sin librerías. */
(function () {
  var doc = document.documentElement;
  var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revelar(root) {
    var els = (root || document).querySelectorAll('.tm-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || quieto) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    // v3.5: si la red fue lenta, el respaldo de CSS ya mostró lo de la primera pantalla; se deja quieto, sin parpadeo.
    var tarde = !root && window.performance && performance.now() > 1800;
    els.forEach(function (e) {
      if (tarde && e.getBoundingClientRect().top < window.innerHeight) { e.style.transition = 'none'; e.classList.add('is-in'); return; }
      var d = e.getAttribute('data-tm-delay');
      if (d) e.style.setProperty('--tm-delay', d + 'ms');
      io.observe(e);
    });
  }

  function contar(root) {
    var nums = (root || document).querySelectorAll('.tm-count[data-to]');
    var fmt = new Intl.NumberFormat('es-CO');
    function correr(el) {
      var fin = parseFloat(el.getAttribute('data-to')) || 0;
      if (quieto) { el.textContent = fmt.format(fin); return; }
      var t0 = null, dur = 1600;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / dur);
        var v = Math.round(fin * (1 - Math.pow(1 - p, 3)));
        el.textContent = fmt.format(v);
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(correr); return; }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) { if (en.isIntersecting) { correr(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.6 });
    nums.forEach(function (n) { io.observe(n); });
  }

  function parallax() {
    var capas = document.querySelectorAll('[data-tm-parallax]');
    if (!capas.length || quieto) return;
    var pendiente = false;
    function pintar() {
      pendiente = false;
      var y = window.scrollY;
      capas.forEach(function (c) {
        var f = parseFloat(c.getAttribute('data-tm-parallax')) || 0.15;
        if (y < window.innerHeight * 1.5) c.style.transform = 'translate3d(0,' + (y * f).toFixed(1) + 'px,0)';
      });
    }
    window.addEventListener('scroll', function () { if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); } }, { passive: true });
  }

  function botonFijo() {
    var barra = document.querySelector('.tm-sticky-cta');
    var ancla = document.querySelector('[data-tm-ancla-cta]');
    if (!barra || !ancla || !('IntersectionObserver' in window)) return;
    // v3.5: la barra se ve siempre que el botón principal no esté en pantalla (también al llegar, antes de bajar).
    new IntersectionObserver(function (e) {
      barra.classList.toggle('is-on', !e[0].isIntersecting);
    }).observe(ancla);
  }

  function iniciar(root) { revelar(root); contar(root); }
  // v3.5: se carga antes que los scripts de Shrine; tm-listo va después de revelar para que el respaldo de CSS no parpadee.
  function arrancar() { iniciar(); parallax(); botonFijo(); doc.classList.add('tm-listo'); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
